import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../../configs/translations'
import type { TCockpitInitiativesView } from '../../../../model/types'

const TAB_KEYS = FINANCIAL_COCKPIT_TRANSLATION_KEYS.keyInitiatives.tabs

export const INITIATIVES_TABS: {
  key: TCockpitInitiativesView
  label: string
  translationKey: string
}[] = [
  { key: 'initiatives', label: 'Initiatives', translationKey: TAB_KEYS.initiatives },
  { key: 'mdf', label: 'MDF', translationKey: TAB_KEYS.mdf },
  { key: 'quality', label: 'Plan Quality', translationKey: TAB_KEYS.quality },
]

/** A tab as the strip reads it — its title, then the figure it wears: the initiatives or MDF
 *  activities it counts, or the Plan Quality score — so the deck repeats the strip. */
export const getInitiativesTabLabel = (
  { key, translationKey }: (typeof INITIATIVES_TABS)[number],
  translate: (key: string) => string,
  figures: Record<TCockpitInitiativesView, string>
) => `${translate(translationKey)} · ${figures[key]}`
